import { render, staticRenderFns } from "./game-grid.vue?vue&type=template&id=aa1bb0da"
import script from "./game-grid.vue?vue&type=script&lang=js"
export * from "./game-grid.vue?vue&type=script&lang=js"
import style0 from "./game-grid.vue?vue&type=style&index=0&id=aa1bb0da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports